import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { FlowLine } from './FlowLine';
import { Ornament } from './Ornament';
const visualItems = ['Step-by-step stretch sequences', 'Start and end positions', 'Directional arrows', 'Body-position guides', 'Working-area indicators', 'Range guidance', 'Class timelines', 'Hold-time guides', 'Correct-vs-incorrect comparisons', 'Easier / Standard / Level Up options', 'Beginner-to-advanced progressions', 'Instructor cues', 'Transition guides', 'Ready-to-teach class structures'];
export function WhyDifferent() {
  return <section className="bg-inverse px-4 py-20 text-inverse-foreground sm:py-28" data-id="element-386" data-mp="d2m1sl3oocsl">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-387" data-mp="i15qgt9nw2on">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-388" data-mp="2xstj4chn791n">
          <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-accent-soft" data-id="element-389" data-mp="3krj5tri47ity">
            <EyeIcon size={16} strokeWidth={1.5} className="text-accent" aria-hidden="true" data-id="element-390" data-mp="3gqh679kad4rg" />
            100% visual core teaching material
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-inverse-foreground sm:text-4xl" data-id="element-391" data-mp="3pp1j1u360k7r">
            One of the Biggest Differences Between Stretching Instructor Ready
            and{' '}
            <span className="italic text-accent-soft" data-id="element-392" data-mp="3iw4z0thchs6">Traditional Flexibility Manuals</span>
          </h2>
          <Ornament align="left" className="mt-5" data-id="element-393" data-mp="ha11vv5gqvyt" />
          <p className="mt-5 text-base leading-7 text-inverse-foreground/75" data-id="element-394" data-mp="hbvpjh84d26l">
            The six-volume core system was designed to help you see the class,
            not fight through pages of theory.
          </p>
          <FlowLine tone="dark" className="mt-6" steps={['See the Position', 'See the Movement', 'See the Progression', 'Teach With Confidence']} data-id="element-395" data-mp="m8uhpu882z25" />
          <p className="mt-8 font-display text-3xl font-semibold leading-tight text-inverse-foreground" data-id="element-396" data-mp="ybeyiuzj1g5h">
            See it. <span className="italic text-accent-soft" data-id="element-397" data-mp="1385fdkj5ofry">Understand it.</span>{' '}
            Teach it.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-accent/40 bg-inverse-raised p-6 shadow-elevated sm:p-9" data-id="element-398" data-mp="1d0kw6eipuyb9">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-accent-soft" data-id="element-399" data-mp="1qzarpppw0pxi">
            Throughout the 100% visual core system you will find:
          </p>
          <ul className="mt-6 grid gap-x-6 sm:grid-cols-2" data-id="element-400" data-mp="3sqe5uoyzkmmt">
            {visualItems.map(item => <li key={item} className="flex items-center gap-2.5 border-b border-inverse-foreground/10 py-3 text-sm font-medium text-inverse-foreground" data-id="element-401" data-mp="3l8pzzaurvh7r">
                <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-accent" aria-hidden="true" data-id="element-402" data-mp="3biwosayjl441" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}